/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DocCertIcon20Solid = forwardRef('DocCertIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.004 2H7a3 3 0 0 0-3 3v9a3 3 0 0 0 3 3h3v2.498a.5.5 0 0 0 .765.424l1.102-.69a.25.25 0 0 1 .265 0l1.103.69a.5.5 0 0 0 .765-.424v-2.669A3.001 3.001 0 0 0 16 14V7.998h-3.746a2.25 2.25 0 0 1-2.25-2.25V2ZM12 16a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z" }),
        React.createElement("path", { d: "m15.863 6.498-4.359-4.359v3.609c0 .414.336.75.75.75h3.61Z" })));
});
